import { useState } from 'react'
import colors from '../../../utils/colors'
import Banner from '../signup/Banner'
import ForgotPasswordForm from './ForgotPasswordForm'
import { IElementObj, ILoginDetails } from '../../../types'
import CheckYourEmail from './CheckYourEmail'
import ResetPasswordForm from './ResetPasswordForm'

interface IProps {
    stepFromRoute?: number
}
const ForgotPassword = ({stepFromRoute}: IProps) => {
    const [step, setStep] = useState(1)
    const [details, setDetails] = useState<ILoginDetails>({} as ILoginDetails);

    const stepsText: any = {
        1: ['Forgot your password?', 'Enter the email address associated with this account so we can send a reset password link'],
        2: ['Check your email', 'A reset password link has been sent to the email address you provided. Click on the link to change your password.'],
        3: ['Reset your password', 'Choose a new password for your account']
    }

    const formToDisplay: any = {
        1: <ForgotPasswordForm setStep = {setStep} details={details} setDetails={setDetails}/>,
        2: <CheckYourEmail details = {details}/>,
        3: <ResetPasswordForm/>
    }
    return (
        <div className='flex'>
            <Banner/>
            <div className='flex flex-col flex-1 gap-[40px] items-center p-[10%]'>
                <div className='flex flex-col w-full gap-[20px]' style={{ color: colors.dark }}>
                    <div className='font-lexend text-[32px] font-[600] leading-normal'>
                        {stepsText[stepFromRoute ?? step][0]}
                    </div>
                    <div className='font-lato text-[20px] font-[400]'>
                        {stepsText[stepFromRoute ?? step][1]}
                    </div>
                </div>
                {formToDisplay[stepFromRoute ?? step]}
            </div>
        </div>
    )
}

export default ForgotPassword